module.exports = __webpack_public_path__ + "static/img/sb05.42fde2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/intellectualProperty/sb05.png
// module id = /no2
// module chunks = 1